import React from 'react';
import {
    Box,
    Typography,
    Stack,
    Link,
    Paper,
} from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=cz.lindosoft.jsdhnotif&hl=cs';
const APP_STORE_URL = 'https://apps.apple.com/cz/app/hasi%C4%8Di-online/id6757203149?l=cs';

const MobileAppSection: React.FC = () => {
    return (
        <Paper
            elevation={2}
            sx={{
                p: 3,
                mt: 4,
                width: '100%',
                textAlign: 'center',
                background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)',
                color: 'common.white',
            }}
        >
            <PhoneIphoneIcon sx={{ fontSize: 40, mb: 1, opacity: 0.9 }} />

            <Typography
                variant="h6"
                component="h2"
                gutterBottom
                sx={{ fontWeight: 700 }}
            >
                Mobilní aplikace
            </Typography>

            <Typography
                variant="body2"
                sx={{ mb: 2, opacity: 0.9 }}
            >
                Stáhněte si aplikaci Hasiči Online pro rychlé notifikace a potvrzení účasti.
            </Typography>

            <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
            >
                <Link
                    href={GOOGLE_PLAY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        display: 'block',
                        transition: 'transform 0.2s ease',
                        '&:hover': {
                            transform: 'scale(1.05)',
                        },
                    }}
                >
                    <Box
                        component="img"
                        src="/badges/google-play-badge.png"
                        alt="Stáhnout na Google Play"
                        sx={{
                            width: 135,
                            height: 'auto',
                        }}
                    />
                </Link>

                <Link
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        display: 'block',
                        transition: 'transform 0.2s ease',
                        '&:hover': {
                            transform: 'scale(1.05)',
                        },
                    }}
                >
                    <Box
                        component="img"
                        src="/badges/app-store-badge.svg"
                        alt="Stáhnout v App Store"
                        sx={{
                            width: 135,
                            height: 'auto',
                        }}
                    />
                </Link>
            </Stack>
        </Paper>
    );
};

export default React.memo(MobileAppSection);
